<template>
  <div>
    <!-- <v-select
      v-model="actualPrinter"
      :options="printers"
      class="margin-multi sp-border-input bg-white w-25 mb-2"
      placeholder="Impresora"
    />-->
    <CRow>
      <CCol sm="12" class="p-0">
        <CCard>
          <div
            class="px-3 flex-column flex-md-row py-2 d-flex justify-content-between w-100 border-bottom align-items-center"
          >
            <h5>Análisis</h5>
            <div class="d-flex align-items-center justify-content-center flex-wrap flex-sm-nowrap">
              <DateSelector initDates="week" @input="e => changeDate(e)" class="margi-dates" />
            </div>
          </div>
          <CCardBody class="p-0 pt-2">
            <CNav justified variant="tabs">
              <CNavItem
                :to="{
            name: 'Analisis'
          }"
                active
              >Análisis por ubicación</CNavItem>
              <CNavItem :to="{
            name: 'AnalisisNomina'
          }">Análisis de nómina</CNavItem>
              <CNavItem
                :to="{
            name: 'AnalisisEficiencia'
          }"
              >Análisis de eficiencia</CNavItem>
            </CNav>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CButtonGroup class="mb-2">
        <CButton @click="changeAnalisis(1)" color="primary">Egresos</CButton>
        <CButton @click="changeAnalisis(2)" color="primary">Ingresos</CButton>
        <CButton @click="changeAnalisis(3)" color="primary">Producción</CButton>
        <div class="d-flex flex-wrap justify-content-between align-items-center" style="margin-left: 10px;" v-if="actualAnalisis == 3">
          <!-- <label for="">Mostrando Cantidad: </label> -->
            <!-- @update:checked="cambiarValores()"  -->
        <label for="">{{mostrandoGrafica}}</label>
          <CSwitch
            @update:checked="cambiarValores()"
            :checked="checked"
            class="mx-1 mr-3"
            color="primary"
            variant="3d"
          />
        </div>
      </CButtonGroup>
      <CCol sm="12" md="12" class="p-0">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex sp-flex justify-content-between text-sm align-items-center catalogo-text"
          >Análisis por ubicación</CCardHeader>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <!-- <tr class="text-center"> -->
                <tr>
                  <th class="custom-width-space-prodc" scope="col"></th>
                  <th v-if="actualAnalisis !== 3" class="custom-width-space-prodc" scope="col">Labores</th>
                  <th v-if="actualAnalisis !== 3" class="custom-width-space-prodc" scope="col">Productos</th>
                  <th v-if="actualAnalisis !== 3" class="custom-width-space-prodc" scope="col">Gastos</th>
                  <th class="custom-width-space-prodc" scope="col">Total</th>
                  <th v-if="actualAnalisis === 3" class="custom-width-space-prodc" scope="col">Plantas</th>
                  <th v-if="actualAnalisis === 3" class="custom-width-space-prodc" scope="col">Producción por planta</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isLoading">
                  <td colspan="7">
                    <div class="w-100 d-flex justify-content-center align-items-center">
                      <div class="sk-flow d-flex align-items-center">
                        <div class="sk-flow-dot bg-primary"></div>
                        <div class="sk-flow-dot bg-primary"></div>
                        <div class="sk-flow-dot bg-primary"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 1 && !isLoading" class="d-table-row">
                  <td class="py-2 cursor-p" @click="toggleHeaders(1)" colspan="5">
                    <span>
                      <CIcon name="cil-chevron-circle-down-alt" />
                    </span>
                    Egresos
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 1 && !isLoading" class="d-table-row ml-4">
                  <td class="m-0 p-0" colspan="5">
                    <CCollapse :show="headersDetails.includes(1)">
                      <table class="table mb-0">
                        <thead v-show="false">
                          <tr>
                            <th scope="col">name</th>
                            <th scope="col">labor</th>
                            <th scope="col">producto</th>
                            <th scope="col">gasto</th>
                            <th scope="col">total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="d-table-row">
                            <td @click="toggleTotal(1)" class="custom-width-space">
                              <span>
                                <CIcon name="cil-chevron-circle-down-alt" />
                              </span>
                              <span>Total</span>
                            </td>
                            <!-- <td class="custom-width-space px-4">
                          {{ "" }}
                            </td>-->
                            <td @click="toggleTotal(1)" class="custom-width-space">
                              {{
                              totalEgresos.labores
                              }}
                            </td>
                            <td @click="toggleTotal(1)" class="custom-width-space">
                              {{
                              totalEgresos.productos
                              }}
                            </td>
                            <td @click="toggleTotal(1)" class="custom-width-space">
                              {{
                              totalEgresos.gastos
                              }}
                            </td>
                            <td @click="toggleTotal(1)" class="custom-width-space">
                              {{
                              totalEgresos.total
                              }}
                            </td>
                          </tr>
                          <!-- <div class="custom-width-total"> -->
                          <tr class="d-table-row">
                            <td class="py-0 pl-2 pr-0" colspan="5">
                              <CCollapse
                                :show="totalDetails.includes(1)"
                                class="m-0 custom-width-total"
                              >
                                <CDataTable
                                  bordered
                                  small
                                  fixed
                                  class="mb-0"
                                  addTableClasses="mb-0"
                                  :header="false"
                                  :loading="isLoading"
                                  :items="filteredItems"
                                  :fields="fields"
                                  :noItemsView="noItems"
                                  pagination
                                >
                                  <template #nombre="{item, index}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 1)"
                                    >
                                      <span>
                                        <CIcon
                                          v-if="
                                            items.filter(
                                              hijo =>
                                                hijo.payload.pertenece_id ==
                                                item.id
                                            ).length > 0
                                          "
                                          name="cil-chevron-circle-down-alt"
                                        />
                                      </span>
                                      {{ item.payload.nombre }}
                                    </td>
                                  </template>
                                  <template #labor="{item}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 1)"
                                    >
                                      {{
                                      item.labor
                                      }}
                                    </td>
                                  </template>
                                  <template #productos="{item}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 1)"
                                    >
                                      {{
                                      item.productos
                                      }}
                                    </td>
                                  </template>
                                  <template #gasto="{item}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 1)"
                                    >
                                      {{
                                      item.gasto
                                      }}
                                    </td>
                                  </template>
                                  <template #total="{item}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 1)"
                                    >
                                      {{
                                      item.total
                                      }}
                                    </td>
                                  </template>

                                  <template v-if="!filter" #details="{item}">
                                    <CCollapse
                                      :show="
                                        details.find(item => item.type == 1)
                                          ? true
                                          : false
                                      "
                                    >
                                      <!-- <CCardBody class="py-0 px-0 pl-2"> -->
                                      <table-collapse
                                        @click-cancel="toggleCancel"
                                        @click-print="printNanoid"
                                        :ubicacionPadre="item.id"
                                        :cultivos="cultivos"
                                        :ubicaciones="
                                          getTableLocations(item, 1)
                                        "
                                      ></table-collapse>
                                    </CCollapse>
                                  </template>
                                </CDataTable>
                              </CCollapse>
                            </td>
                          </tr>
                          <!-- </div> -->
                        </tbody>
                      </table>
                    </CCollapse>
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 2 && !isLoading" class="d-table-row">
                  <td class="py-2 cursor-p" @click="toggleHeaders(2)" colspan="5">
                    <span>
                      <CIcon name="cil-chevron-circle-down-alt" />
                    </span>
                    Ingresos
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 2 && !isLoading" class="d-table-row">
                  <td class="m-0 p-0" colspan="5">
                    <CCollapse :show="headersDetails.includes(2)">
                      <table class="table mb-0">
                        <thead v-show="false">
                          <tr>
                            <th scope="col">name</th>
                            <th scope="col">labor</th>
                            <th scope="col">producto</th>
                            <th scope="col">gasto</th>
                            <th scope="col">total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="d-table-row">
                            <td @click="toggleTotal(2)" class="custom-width-space d-table-cell">
                              <span>
                                <CIcon name="cil-chevron-circle-down-alt" />
                              </span>
                              <span>Total</span>
                            </td>

                            <td @click="toggleTotal(2)" class="custom-width-space">{{ "" }}</td>
                            <td @click="toggleTotal(2)" class="custom-width-space">{{ "" }}</td>
                            <td @click="toggleTotal(2)" class="custom-width-space">{{ "" }}</td>
                            <td @click="toggleTotal(2)" class="custom-width-space">
                              {{
                              $formatter(totalIngresos.total
                              ? totalIngresos.total
                              : 0,1)
                              }}
                            </td>
                          </tr>
                          <tr class="d-table-row">
                            <td class="py-0 pl-0 pr-0" colspan="5">
                              <CCollapse
                                :show="totalDetails.includes(2)"
                                class="m-0 custom-width-total"
                              >
                                <CDataTable
                                  bordered
                                  small
                                  fixed
                                  class="mb-0"
                                  addTableClasses="mb-0"
                                  :header="false"
                                  :loading="isLoading"
                                  :items="filteredItemsIngresos"
                                  :fields="fields"
                                  :noItemsView="noItems"
                                  pagination
                                >
                                  <template #nombre="{item, index}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 2)"
                                    >
                                      <span>
                                        <CIcon
                                          v-if="
                                            items.filter(
                                              hijo =>
                                                hijo.payload.pertenece_id ==
                                                item.id
                                            ).length > 0
                                          "
                                          name="cil-chevron-circle-down-alt"
                                        />
                                      </span>
                                      {{ item.payload.nombre }}
                                    </td>
                                  </template>
                                  <template #labor="{item}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 2)"
                                    >
                                      {{
                                      item.labor
                                      }}
                                    </td>
                                  </template>
                                  <template #productos="{item}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 2)"
                                    >
                                      {{
                                      item.productos
                                      }}
                                    </td>
                                  </template>
                                  <template #gasto="{item}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 2)"
                                    >
                                      {{
                                      item.gasto
                                      }}
                                    </td>
                                  </template>
                                  <template #total="{item}">
                                    <td
                                      class="custom-width-space"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 2)"
                                    >
                                      {{ item.total }}
                                    </td>
                                  </template>

                                  <template v-if="!filter" #details="{item}">
                                    <CCollapse
                                      :show="
                                        details.find(item => item.type == 2)
                                          ? true
                                          : false
                                      "
                                    >
                                      <!-- <CCardBody class="py-0 px-0 pl-2"> -->
                                      <table-collapse
                                        @click-cancel="toggleCancel"
                                        @click-print="printNanoid"
                                        :ubicacionPadre="item.id"
                                        :cultivos="cultivos"
                                        :ubicaciones="
                                          getTableLocations(item, 2)
                                        "
                                      ></table-collapse>
                                    </CCollapse>
                                  </template>
                                </CDataTable>
                              </CCollapse>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </CCollapse>
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 3 && !isLoading" class="d-table-row">
                  <td class="py-2 cursor-p" @click="toggleHeaders(3)" colspan="7">
                    <span>
                      <CIcon name="cil-chevron-circle-down-alt" />
                    </span>
                    Producción
                  </td>
                </tr>
                <tr v-if="actualAnalisis == 3 && !isLoading" class="d-table-row">
                  <td class="m-0 p-0" colspan="7">
                    <CCollapse :show="headersDetails.includes(3)">
                      <table class="table mb-0">
                        <thead v-show="false">
                          <tr>
                            <th scope="col">name</th>
                            <th scope="col">total</th>
                            <th scope="col">Plantas</th>
                            <th scope="col">Producción por planta</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="d-table-row">
                            <td @click="toggleTotal(3)" class="custom-width-space-prodc d-table-cell">
                              <span>
                                <CIcon name="cil-chevron-circle-down-alt" />
                              </span>
                              <span>Total</span>
                            </td>

                            <td @click="toggleTotal(3)" class="custom-width-space-prodc">
                              {{
                              totalProduccion.total
                              ? totalProduccion.total


                              : "0"
                              }}
                              <!-- {{totalProduccion}} -->
                            </td>
                            <td @click="toggleTotal(3)" class="custom-width-space-prodc">{{ $formatter(getPlantasTot(),false,'.00') }}</td>
                            <td @click="toggleTotal(3)" class="custom-width-space-prodc">{{ getProduccionTot(totalProduccion.total) }}</td>
                          </tr>
                          <tr class="d-table-row">
                            <td class="py-0 pl-0 pr-0" colspan="8">
                              <CCollapse
                                :show="totalDetails.includes(3)"
                                class="m-0 custom-width-total"
                              >
                                <CDataTable
                                  bordered
                                  small
                                  fixed
                                  class="mb-0"
                                  addTableClasses="mb-0"
                                  :header="false"
                                  :loading="isLoading"
                                  :items="filteredItemsProduccion"
                                  :fields="fieldsProdc"
                                  :noItemsView="noItems"
                                  pagination
                                >
                                  <template #nombre="{item, index}">
                                    <td
                                      class="custom-width-space-prodc"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index, 3)"
                                    >
                                      <span>
                                        <CIcon
                                          v-if="
                                            items.filter(
                                              hijo =>
                                                hijo.payload.pertenece_id ==
                                                item.id
                                            ).length > 0
                                          "
                                          name="cil-chevron-circle-down-alt"
                                        />
                                      </span>
                                      {{ item.payload.nombre }}
                                    </td>
                                  </template>
                                  <template #total="{item}">
                                    <td
                                      class="custom-width-space-prodc"
                                      :class="
                                        `${
                                          items.filter(
                                            hijo =>
                                              hijo.payload.pertenece_id ==
                                              item.id
                                          ).length > 0
                                            ? `cursor-p`
                                            : ``
                                        }`
                                      "
                                      @click="toggleUbicaciones(index)"
                                    >
                                    <!-- {{item}} -->
                                      {{
                                      item.total
                                      }}
                                    </td>
                                  </template>
                                  <template #plantas="{item}">
                                    <td class="custom-width-space-prodc"
                                      @click="toggleUbicaciones(index)"
                                    >
                                      {{ $formatter(getPlantasTot(),false,'.00') }}

                                      <!-- {{
                                        item.total.replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ","
                                        )holappros
                                      }} -->
                                    </td>
                                  </template>
                                  <template #produccion_plantas="{item}">
                                    <td
                                      class="custom-width-space-prodc"
                                      @click="toggleUbicaciones(index)"
                                    >
                                      {{ getProduccionTot(item.total) }}
                                    </td>
                                  </template>

                                  <template v-if="!filter" #details="{item}">
                                    <CCollapse
                                      :show="
                                        details.find(item => item.type == 3)
                                          ? true
                                          : false
                                      "
                                    >
                                      <!-- <CCardBody class="py-0 px-0 pl-2"> -->
                                      <table-collapse
                                        @click-cancel="toggleCancel"
                                        @click-print="printNanoid"
                                        :ubicacionPadre="item.id"
                                        :cultivos="cultivos"
                                        :ubicaciones="
                                          getTableLocations(item, 3)
                                        "
                                        :tabla="actualAnalisis"
                                      ></table-collapse>
                                    </CCollapse>
                                  </template>
                                </CDataTable>
                              </CCollapse>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </CCollapse>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import axios from "axios";
import DateSelector from "../../../customComponents/DateSelector";
import moment from "moment";

const fields = [
  { key: "nombre", _style: "width:0%" },
  { key: "labor", _style: "width:20%" },
  { key: "productos", _style: "width:20%" },
  { key: "gastos", _style: "width:20%" },
  { key: "total", _style: "width:20%" }
];
const fieldsProdc = [
  { key: "nombre", _style: "width:0%" },
  { key: "total", _style: "width:15%" },
  { key: "plantas", _style: "width:15%" },
  { key: "produccion_plantas", _style: "width:15%" }
];

const fieldsHeaders = [
  { key: "name", label: "", _style: "width:20%" },
  { key: "labores", label: "Labores", _style: "width:20%" },
  { key: "productos", label: "Productos", _style: "width:20%" },
  { key: "gastos", label: "Gastos", _style: "width:20%" },
  { key: "total", label: "Total", _style: "width:20%" },
  { key: "plantas", _style: "width:20%" },
  { key: "produccion_plantas", _style: "width:20%" }
];

import TableCollapse from "../../../customComponents/TableCollapseAnalisis";

export default {
  name: "AnalisisUbicacion",

  components: {
    TableCollapse,
    DateSelector
  },

  data() {
    return {
      checked: false,
      items: [],
      itemsProduccion: [],
      itemsIngresos: [],
      itemsEgresos: [],
      cultivos: [],
      fields,
      fieldsProdc,
      fieldsHeaders,
      filter: "",
      dropdownCustom: false,
      allSelections: false,
      cancelModal: false,
      details: [],
      actualAnalisis: 1,
      detailEgresos: [],
      detailProduccion: [],
      headersDetails: [],
      totalDetails: [],
      isLoading: false,
      printModal: false,
      cancelSource: null,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      itemModalPrint: { cantidadCopias: 1 },
      itemModal: { id: "", name: "", index: "" },
      totalIngresos: {
        name: "",
        labores: "",
        productos: "",
        gastos: "",
        total: ""
      },
      totalEgresos: {
        name: "",
        labores: "",
        productos: "",
        gastos: "",
        total: ""
      },
      totalProduccion: {
        name: "",
        labores: "",
        productos: "",
        gastos: "",
        total: ""
      },
      headersItems: [
        {
          name: "Egresos",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Ingresos",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Producción",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        }
      ],
      egresosTotal: [
        {
          name: "Total",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Ingresos",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        },
        {
          name: "Producción",
          labores: "",
          productos: "",
          gastos: "",
          total: ""
        }
      ]
    };
  },

  created() {
    this.updateAllInfo();
    // const ubicacionTemplateRaiz = [
    //   this.$store.dispatch("customHTTP", {
    //     schema: "ubicaciones",
    //     filter: {
    //       where: [
    //         {
    //           field: "payload->raiz_id",
    //           value: this.ubicacionRaizValue,
    //           operator: "="
    //         }
    //       ]
    //     }
    //   })
    // ];
    // const ubicacionTemplateNoRaiz = [
    //   this.$store.dispatch("customHTTP", {
    //     schema: "ubicaciones"
    //   })
    // ];
    // this.isLoading = true;
    // const ubi = [
    //   this.$store.dispatch("customHTTP", { schema: "cultivos" })
    //   // this.$store.dispatch("customHTTP", { schema: "ubicaciones" })
    // ];

    // if (this.ubicacionRaizValue) {
    //   ubi.push(...ubicacionTemplateRaiz);
    // } else {
    //   ubi.push(...ubicacionTemplateNoRaiz);
    // }

    // // this.$store
    // //   .dispatch("customHTTP", { schema: "ubicaciones" })
    // Promise.all(ubi)
    //   .then(([cultivos, ubicaciones]) => {
    //     this.cultivos = cultivos.data;
    //     this.items = ubicaciones.data
    //       ? ubicaciones.data.map(ubi => {
    //           return { ...ubi, selected: false };
    //         })
    //       : [];
    //   })
    //   .finally(() => (this.isLoading = false));
  },

  computed: {
    mostrandoGrafica() {
      if (this.checked) {
        return "Mostrando equivalencia: "
      }else{
        return "Mostrando cantidad: "
      }
    },
    printers() {
      return window.printersDetected();
    },
    actualPrinter() {
      return window.printerAct();
      // ? { value: window.printerAct.uid, label: window.printerAct.name }
      // : null;
    },
    filteredItems() {
      return this.itemsEgresos.filter(i => i.payload.pertenece_id == 0);
      // .filter(i =>
      //   i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
      // );
    },
    filteredItemsIngresos() {
      return this.itemsIngresos.filter(i => i.payload.pertenece_id == 0);
    },
    filteredItemsProduccion() {
      return this.itemsProduccion.filter(i => i.payload.pertenece_id == 0);
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    datesGraph() {
      return this.$store.state.dateGraphs;
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.searchTimeOut();
    },
    actualAnalisis: function() {
      this.searchTimeOut();
    },
    datesGraph: function() {
      this.searchTimeOut();
    }
  },

  methods: {
    cambiarValores() {
      this.checked = !this.checked
      this.updateAllInfo()
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.updateAllInfo();
      }, 800);
    },
    onClickPrintCodes() {
      this.printModal = true;
      this.closeDropdown();
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    selectAll() {
      if (this.allSelections) {
        this.items = this.items
          ? this.items.map(ubi => {
              return { ...ubi, selected: false };
            })
          : [];
        this.allSelections = false;
      } else {
        this.items = this.items
          ? this.items.map(ubi => {
              return { ...ubi, selected: true };
            })
          : [];
        this.allSelections = true;
      }
    },
    printItems() {
      const idsToPrint = this.items.filter(item => item.selected === true);

      idsToPrint.length
        ? idsToPrint.map(ubicacion => {
            this.printNanoid(ubicacion, this.itemModalPrint.cantidadCopias);
          })
        : null;

      this.printModal = false;
    },
    printNanoid(ubicacion, cant) {
      if (ubicacion && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${ubicacion.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${ubicacion.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivos.filter(
        cultivo => cultivo.id == cultivo_id
      );

      return cultivoActual[0].payload.nombre;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: this.items.indexOf(item)
      };
      this.itemModal = itemIndex;
    },
    toggleUbicaciones(index, type) {
      const item = { index: index, type: type };

      const position = this.details.findIndex(item => item.type == type);

      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(item);
    },
    toggleTotal(index) {
      const position = this.totalDetails.indexOf(index);
      position !== -1
        ? this.totalDetails.splice(position, 1)
        : this.totalDetails.push(index);
    },
    toggleHeaders(index) {
      const position = this.headersDetails.indexOf(index);
      position !== -1
        ? this.headersDetails.splice(position, 1)
        : this.headersDetails.push(index);
    },
    deleteUbicacion(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "ubicaciones",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    },
    updateAllInfo() {
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();

      const ubicacionTemplateRaiz = [
        "customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->raiz_id",
                value: this.ubicacionRaizValue,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        }
      ];
      const ubicacionTemplateNoRaiz = [
        "customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        }
      ];
      const ingresosTemplate = [
        "customIndicadoresHTTP", {
          body: {
            reporte: "ingresos_analisis",
            params: {
              //fecha: this.datesGraph,
              fecha: this.datesGraph,
              ubicaciones: [this.ubicacionRaizValue],
              cultivo_id: ""
              // cultivo_id: this.cropGraphs ? this.cropGraphs.value : ""
            }
          },
          cancelToken: this.cancelSource
        }
      ];
      const costosTemplate = [
        "customIndicadoresHTTP", {
          body: {
            reporte: "costos_analisis",
            params: {
              //fecha: this.datesGraph,
              fecha: this.datesGraph,
              ubicaciones: [this.ubicacionRaizValue],
              cultivo_id: ""
              // cultivo_id: this.cropGraphs ? this.cropGraphs.value : ""
            }
          },
          cancelToken: this.cancelSource
        }
      ];
      const produccionTemplate = [
        "customIndicadoresHTTP", {
          body: {
            reporte: "produccion_analisis",
            params: {
              //fecha: this.datesGraph,
              fecha: this.datesGraph,
              ubicaciones: [this.ubicacionRaizValue],
              cultivo_id: ""
              // cultivo_id: this.cropGraphs ? this.cropGraphs.value : ""
            }
          },
          cancelToken: this.cancelSource
        }
      ];
      this.isLoading = true;
      const ubi = [];
      if (this.ubicacionRaizValue) {
        ubi.push(this.$store.dispatch(...ubicacionTemplateRaiz));
      } else {
        ubi.push(this.$store.dispatch(...ubicacionTemplateNoRaiz));
      }
      if (this.actualAnalisis == 1) {
        ubi.push(this.$store.dispatch(...costosTemplate));
        Promise.all(ubi)
          .then(([ubicaciones, costos]) => {
            this.items = ubicaciones.data;

            // Egresos
            this.itemsEgresos = ubicaciones.data
              ? ubicaciones.data.map(ubi => {

                  const actualLabor = costos.data.find(
                    item =>
                      item.ubicacion == ubi.payload.nombre &&
                      item.concepto == "actividad"
                  );
                  const actualProducto = costos.data.find(
                    item =>
                      item.ubicacion == ubi.payload.nombre &&
                      item.concepto == "producto"
                  );
                  const actualGasto = costos.data.find(
                    item =>
                      item.ubicacion == ubi.payload.nombre &&
                      item.concepto == "servicio"
                  );

                  if (!ubi.payload.cultivo_id) {
                    const hojasLabor = costos.data.filter(
                      item =>
                        item.ubicacion_ruta
                          .split("/")
                          .includes(ubi.payload.nombre) &&
                        item.concepto == "actividad"
                    );
                    const hojasProducto = costos.data.filter(
                      item =>
                        item.ubicacion_ruta
                          .split("/")
                          .includes(ubi.payload.nombre) &&
                        item.concepto == "producto"
                    );
                    const hojasGasto = costos.data.filter(
                      item =>
                        item.ubicacion_ruta
                          .split("/")
                          .includes(ubi.payload.nombre) &&
                        item.concepto == "servicio"
                    );

                    const totalLabor = hojasLabor.reduce(
                      (acum, item) => (acum += Number(item.total.toFixed(2))),
                      0
                    );
                    const totalProducto = hojasProducto.reduce(
                      (acum, item) => (acum += Number(item.total.toFixed(2))),
                      0
                    );
                    const totalGasto = hojasGasto.reduce(
                      (acum, item) => (acum += Number(item.total.toFixed(2))),
                      0
                    );
                    const total = (
                        Number(totalGasto) +
                        Number(totalLabor) +
                        Number(totalProducto)
                      )
                    return {
                      ...ubi,
                      labor: this.$formatter(totalLabor,true),
                      productos: this.$formatter(totalProducto,true),
                      gastos: this.$formatter(totalGasto,true),
                      total: this.$formatter(total,true),
                      selected: false
                    };
                  } else {
                    console.log({actualLabor,actualProducto,actualGasto,})

                    const total = (actualLabor?actualLabor.total:0) +
                              (actualProducto?actualProducto.total:0) +
                              (actualGasto?actualGasto.total:0);

                    return {
                      ...ubi,
                      labor:  this.$formatter(actualLabor?actualLabor.total:0 ,true),
                      productos:  this.$formatter(actualProducto?actualProducto.total:0 ,true),
                      gastos:  this.$formatter(actualGasto?actualGasto.total:0,true),
                      total: this.$formatter(total,true),
                      selected: false
                    };
                  }
                })
              : [];

            this.totalEgresos = this.itemsEgresos
              .filter(item => (item.payload.cultivo_id ? true : false))
              .reduce(
                (acum, item) => {
                  acum["labores"] += Number(this.$OnlyNumber(item.labor));
                  acum["productos"] += Number(this.$OnlyNumber(item.productos));
                  acum["gastos"] += Number(this.$OnlyNumber(item.gastos));
                  acum["total"] += Number(this.$OnlyNumber(item.total));
                  return acum;
                },
                { name: "", labores: 0, productos: 0, gastos: 0, total: 0 }
              );

            this.totalEgresos.labores = this.$formatter(this.totalEgresos.labores,true)
            this.totalEgresos.productos = this.$formatter(this.totalEgresos.productos,true)
            this.totalEgresos.gastos = this.$formatter(this.totalEgresos.gastos,true)
            this.totalEgresos.total = this.$formatter(this.totalEgresos.total,true)
            this.isLoading = false;
          })
          .catch(err => {
            if (err !== "Stop") {
              this.isLoading = false;
            }
          });
      } else if (this.actualAnalisis == 2) {
        ubi.push(this.$store.dispatch(...ingresosTemplate));
        Promise.all(ubi)
          .then(([ubicaciones, indicadores]) => {
            this.items = ubicaciones.data;

            // Ingresos
            this.itemsIngresos = ubicaciones.data
              ? ubicaciones.data.map(ubi => {
                  const actualIndicator = indicadores.data.find(
                    item => item.ubicacion == ubi.payload.nombre
                  );

                  if (!ubi.payload.cultivo_id) {
                    const hojas = indicadores.data.filter(item =>
                      item.ubicacion_ruta
                        .split("/")
                        .includes(ubi.payload.nombre)
                    );
                    const totalRama = hojas.reduce(
                      (acum, item) => (acum += item.total),
                      0
                    );
                    return {
                      ...ubi,
                      labor: "",
                      productos: "",
                      gastos: "",
                      total: this.$formatter(totalRama,1),
                      selected: false
                    };
                  } else {
                    return {
                      ...ubi,
                      labor: "",
                      productos: "",
                      gastos: "",
                      total: this.$formatter(actualIndicator?.total??0,1),
                      selected: false
                    };
                  }
                })
              : [];
            this.totalIngresos = indicadores.data.reduce(
              (acum, item) => {
                acum["total"] += item.total;
                return acum;
              },
              { name: "", labores: "", productos: "", gastos: "", total: 0 }
            );
            this.isLoading = false;
          })
          .catch(err => {
            if (err !== "Stop") {
              this.isLoading = false;
            }
          });
      } else if (this.actualAnalisis == 3) {
        ubi.push(this.$store.dispatch(...produccionTemplate));
        Promise.all(ubi)
          .then(([ubicaciones, produciones]) => {
            this.items = ubicaciones.data;
            // Producciones
            this.itemsProduccion = ubicaciones.data
              ? ubicaciones.data.map(ubi => {
                  const actualIndicator = produciones.data.find(
                    item => item.ubicacion == ubi.payload.nombre
                  );

                  if (!ubi.payload.cultivo_id) {
                    const hojas = produciones.data.filter(item =>
                      item.ubicacion_ruta
                        .split("/")
                        .includes(ubi.payload.nombre)
                    );
                    // console.log(hojas)
                    const totalRama = hojas.reduce(
                      (acum, item) => (acum += this.checked ? item.total : item.cantidad),
                      // (acum, item) => (acum += item.total),
                      0
                    );

                    // filteredItemsProduccion holappros
                    return {
                      ...ubi,
                      labor: "",
                      productos: "",
                      gastos: "",
                      total: totalRama ? `${totalRama.toFixed(2)}` : "0",
                      selected: false
                    };
                  } else {
                    return {
                      ...ubi,
                      labor: "",
                      productos: "",
                      gastos: "",
                      total: actualIndicator
                        // ? `${actualIndicator.total.toFixed(2)}`
                        ? (this.checked ? `${actualIndicator.total.toFixed(2)}` : `${actualIndicator.cantidad.toFixed(2)}`)
                        // ? (`${actualIndicator.total.toFixed(2)}`)
                        : "0",
                      selected: false
                    };
                  }
                })
              : [];
            // console.log(this.itemsProduccion)
            this.totalProduccion = produciones.data.reduce(
              (acum, item) => {
                acum["total"] += this.checked ? item.total : item.cantidad;
                // acum["total"] += item.total;
                return acum;
              },
              { name: "", labores: "", productos: "", gastos: "", total: 0 }
            );
            this.isLoading = false;
          })
          .catch(err => {
            if (err !== "Stop") {
              this.isLoading = false;
            }
          });
      }
    },
    getPlantasTot(id) {
      let cant = 0
      for (let index = 0; index < this.itemsProduccion.length; index++) {
        const element = this.itemsProduccion[index];
        if (element.payload.cantidad_plantas) {
          cant += element.payload.cantidad_plantas
        }
        // const ubi = element.payload.ruta.slice(1,-1).split('/')
        // console.log(element.payload.ruta.slice(1,-1).split('/'))

      }
      return cant
    },
    getProduccionTot(total) {
      let cant = 0
      for (let index = 0; index < this.itemsProduccion.length; index++) {
        const element = this.itemsProduccion[index];
        if (element.payload.cantidad_plantas) {
          cant += element.payload.cantidad_plantas
        }
      }
      return cant?((total/cant).toFixed(3)):0
    },
    // toggleSubUbicaciones(index) {
    //   const positionSub = this.subDetails.indexOf(index);
    //   positionSub !== -1
    //     ? this.subDetails.splice(positionSub, 1)
    //     : this.subDetails.push(index);
    // }

    getTableLocations(item, type) {
      if (type == 1) {
        return this.itemsEgresos.filter(
          hijo => hijo.payload.raiz_id == item.id
        );
      } else if (type == 2) {
        return this.itemsIngresos.filter(
          hijo => hijo.payload.raiz_id == item.id
        );
      } else {
        return this.itemsProduccion.filter(
          hijo => hijo.payload.raiz_id == item.id
        );
      }
    },
    changeAnalisis(value) {
      if (value) {
        this.actualAnalisis = value;
      }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Stop");
        console.log("cancel request done");
      }
    },
    changeDate(e) {
      const datesValues = [
        moment(e.start).format("YYYY-MM-DD"),
        moment(e.end).format("YYYY-MM-DD")
      ];
      this.$store.dispatch("setDateGraph", datesValues);
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.layout {
  table-layout: fixed;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  /* width: 50%;
  white-space: nowrap; */
}
.custom-width-space {
  /* display: table-cell; */
  width: 20% !important;
}
.custom-width-space-prodc {
  /* display: table-cell; */
  width: 15% !important;
}
.custom-width-td {
  width: 70%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100%;
}
.sp-border-input {
  border-radius: 4px;
}
.sp-flex {
  flex-direction: row;
}
.sp-margin-b {
  margin-bottom: 0;
}
.sp-width-butom {
  width: 160px;
}
.cursor-p {
  cursor: pointer;
}

@media (max-width: 768px) {
  .sp-flex {
    flex-direction: column;
  }
  .sp-margin-b {
    margin-bottom: 0.8rem;
  }
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>

// const indicadores = [ // this.$store.dispatch("customIndicadoresHTTP", { //
reporte: "ingresos_analisis", // params: { // // fecha: this.datesGraph, //
fecha: ["2020-05-06", "2020-09-14"], // ubicaciones: [this.ubicacionRaiz], //
cultivo_id: "" // // cultivo_id: this.cropGraphs ? this.cropGraphs.value : "" //
} // }) // ];
